/*
 * Klaviyo Back in Stock: notify-me form (Phan Creative kit v1.1, Oct 2026)
 * Paired with snippets/klaviyo-back-in-stock.liquid + assets/klaviyo-back-in-stock.css.
 * On SPRWMN this file is named back-in-stock-alerts.js: Flash Speed delays any
 * script whose URL contains "klaviyo" until the shopper interacts.
 * No dependencies, theme-agnostic. Posts to Klaviyo's client APIs with the
 * PUBLIC key only:
 *   1. SMS consent (if a phone was given)  -> POST /client/subscriptions/ (SMS list)
 *   2. Back in stock subscription          -> POST /client/back-in-stock-subscriptions/
 *   3. Optional email marketing opt-in     -> POST /client/subscriptions/ (email list)
 * Klaviyo then watches Shopify inventory for that VARIANT and fires the
 * "Subscribed to Back in Stock" flow when it restocks.
 */
(function () {
  'use strict';
  if (window.KlaviyoBIS) return;

  var API = 'https://a.klaviyo.com/client/';
  var REVISION = '2026-07-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  var DEFAULT_STRINGS = {
    needOne: 'Enter your email or phone number.',
    badEmail: 'Enter a valid email address.',
    badPhone: 'Enter a valid mobile number, like (555) 555-5555.',
    generic: 'Something went wrong. Please try again.',
    smsFailed: 'We couldn’t add your phone number, but we’ll email you.',
    sending: 'Sending…',
    successEmail: 'We’ll email you as soon as {item} is back.',
    successSms: 'We’ll text you as soon as {item} is back.',
    successBoth: 'We’ll email and text you as soon as {item} is back.',
    thisItem: 'this item'
  };

  function detectPublicKey() {
    var s = document.querySelector('script[src*="klaviyo.js"][src*="company_id="]');
    var m = s && s.src.match(/company_id=([A-Za-z0-9]+)/);
    return m ? m[1] : '';
  }

  // Returns E.164 (+15555555555) or '' when it can't be made valid.
  function normalizePhone(raw, cc) {
    var s = String(raw || '').trim();
    if (!s) return '';
    var digits = s.replace(/\D/g, '');
    if (s.charAt(0) === '+') return digits.length >= 8 ? '+' + digits : '';
    if (digits.indexOf('00') === 0) return '+' + digits.slice(2);
    cc = String(cc || '1');
    if (cc === '1') {
      if (digits.length === 10) return '+1' + digits;
      if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
      return '';
    }
    digits = digits.replace(/^0+/, '');
    return digits.length >= 6 ? '+' + cc + digits : '';
  }

  function post(path, key, payload) {
    return fetch(API + path + '/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (res.ok) return res;
      return res.json().catch(function () { return {}; }).then(function (j) {
        var err = (j && j.errors && j.errors[0]) || {};
        var e = new Error(err.detail || 'HTTP ' + res.status);
        e.status = res.status;
        e.pointer = (err.source && err.source.pointer) || '';
        throw e;
      });
    });
  }

  function subscribeToList(key, listId, profileAttrs, source) {
    return post('subscriptions', key, {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: { data: { type: 'profile', attributes: profileAttrs } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    });
  }

  function subscribeBackInStock(key, variantId, email, phone) {
    var attrs = {};
    var channels = [];
    if (email) { attrs.email = email; channels.push('EMAIL'); }
    if (phone) { attrs.phone_number = phone; channels.push('SMS'); }
    return post('back-in-stock-subscriptions', key, {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: attrs } },
          channels: channels
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
        }
      }
    });
  }

  function init(root) {
    if (!root || root.__kbis) return;
    root.__kbis = true;

    var cfgEl = root.querySelector('[data-kbis-config]');
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var key = cfg.publicKey || detectPublicKey();
    if (!key) { console.warn('[klaviyo-bis] No Klaviyo public key; form disabled.'); return; }

    var S = {};
    Object.keys(DEFAULT_STRINGS).forEach(function (k) { S[k] = (cfg.strings && cfg.strings[k]) || DEFAULT_STRINGS[k]; });

    var variants = {};
    (cfg.variants || []).forEach(function (v) { variants[String(v.id)] = v; });

    var form = cfg.formId ? document.getElementById(cfg.formId) : root.closest('form');
    var $ = function (sel) { return root.querySelector(sel); };
    var trigger = $('[data-kbis-trigger]');
    var panel = $('[data-kbis-panel]');
    var formView = $('[data-kbis-form]');
    var successView = $('[data-kbis-success]');
    var successText = $('[data-kbis-success-text]');
    var variantLabel = $('[data-kbis-variant]');
    var emailEl = $('[data-kbis-email]');
    var phoneEl = $('[data-kbis-phone]');
    var optinEl = $('[data-kbis-optin]');
    var legalEl = $('[data-kbis-legal]');
    var submitEl = $('[data-kbis-submit]');
    var statusEl = $('[data-kbis-status]');
    var current = String(cfg.initialVariant || '');
    var busy = false;

    function eligible(v) {
      // Klaviyo can only detect a restock when Shopify tracks inventory and
      // "continue selling when out of stock" is off.
      return !!v && !v.a && v.m === 'shopify' && v.p === 'deny';
    }

    function itemName(v) {
      if (!v || !v.t || v.t === 'Default Title') return cfg.productTitle || S.thisItem;
      return v.t;
    }

    function setStatus(msg, isError) {
      statusEl.textContent = msg || '';
      statusEl.classList.toggle('kbis__status--error', !!isError);
    }

    function markInvalid(el) {
      [emailEl, phoneEl].forEach(function (f) { if (f) f.removeAttribute('aria-invalid'); });
      if (el) { el.setAttribute('aria-invalid', 'true'); el.focus(); }
    }

    function reset() {
      setStatus('');
      markInvalid(null);
      formView.hidden = false;
      successView.hidden = true;
      trigger.hidden = false;
    }

    function collapse() {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }

    function render() {
      var v = variants[current];
      var show = eligible(v);
      root.hidden = !show;
      if (!show) { collapse(); return; }
      if (variantLabel) variantLabel.textContent = itemName(v);
    }

    function setVariant(id) {
      id = String(id || '');
      if (!id || id === current || !variants[id]) return;
      current = id;
      reset();
      collapse();
      render();
    }

    function toggleLegal() {
      if (legalEl) legalEl.hidden = !(phoneEl && phoneEl.value.trim());
    }

    // --- variant tracking -------------------------------------------------
    // setVariant() ignores ids that aren't this product's, so the document-level
    // listeners are safe with quick views or several forms on one page.
    function onVariantEvent(e) {
      var v = e && e.detail && (e.detail.variant || e.detail);
      if (v && v.id) setVariant(v.id);
    }
    // Focal / Impact / Prestige / Warehouse fire 'variant:changed' on the form.
    if (form) form.addEventListener('variant:changed', onVariantEvent);
    // Archetype Motion fires 'variantChange' on the section and 'variant:change' on document.
    document.addEventListener('variant:change', onVariantEvent);
    var section = root.closest('.shopify-section') || (form && form.closest('.shopify-section'));
    if (section) section.addEventListener('variantChange', onVariantEvent);

    // Fallback for every theme: watch the form's [name=id] and ?variant=.
    var lastInput = null;
    var lastUrl = null;
    function checkInputs() {
      var input = form && (form.querySelector('[name="id"]:not([disabled])') || form.querySelector('[name="id"]'));
      var iv = input ? String(input.value) : '';
      if (iv && iv !== lastInput) { if (lastInput !== null) setVariant(iv); lastInput = iv; }
      var uv = new URLSearchParams(window.location.search).get('variant') || '';
      if (uv && uv !== lastUrl) { if (lastUrl !== null) setVariant(uv); lastUrl = uv; }
    }
    // Custom pickers that write [name=id] in their own change handler (SPRWMN):
    // re-check right after any change instead of waiting for the next poll.
    document.addEventListener('change', function () { setTimeout(checkInputs, 0); });
    setInterval(function () { if (!document.hidden) checkInputs(); }, 400);

    // --- UI -------------------------------------------------------------
    trigger.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      trigger.setAttribute('aria-expanded', String(open));
      if (open && emailEl) emailEl.focus();
    });

    if (phoneEl) phoneEl.addEventListener('input', toggleLegal);
    toggleLegal();

    formView.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.tagName === 'INPUT' && e.target.type !== 'checkbox') {
        e.preventDefault(); // never let Enter submit a surrounding product form
        submit();
      }
    });
    submitEl.addEventListener('click', submit);

    function fail(msg, el) {
      busy = false;
      submitEl.disabled = false;
      submitEl.removeAttribute('aria-busy');
      markInvalid(el || null);
      setStatus(msg, true);
    }

    function fieldFromError(err) {
      if (/phone/.test(err.pointer)) return { msg: S.badPhone, el: phoneEl };
      if (/email/.test(err.pointer)) return { msg: S.badEmail, el: emailEl };
      return { msg: S.generic, el: null };
    }

    function submit() {
      if (busy) return;
      var email = emailEl ? emailEl.value.trim() : '';
      var phoneRaw = phoneEl ? phoneEl.value.trim() : '';
      var phone = phoneRaw ? normalizePhone(phoneRaw, cfg.countryCode) : '';

      if (!email && !phoneRaw) return fail(S.needOne, emailEl || phoneEl);
      if (email && !EMAIL_RE.test(email)) return fail(S.badEmail, emailEl);
      if (phoneRaw && !phone) return fail(S.badPhone, phoneEl);

      busy = true;
      submitEl.disabled = true;
      submitEl.setAttribute('aria-busy', 'true');
      markInvalid(null);
      setStatus(S.sending);

      var variantId = current;
      var v = variants[variantId];
      var source = cfg.source || 'Back in stock form';
      var smsNote = '';

      // 1. SMS consent first. Klaviyo will only text people who opted in.
      var smsStep = (phone && cfg.smsListId)
        ? subscribeToList(key, cfg.smsListId, { phone_number: phone }, source).then(
            function () { return phone; },
            function (err) {
              if (!email) throw err;
              smsNote = S.smsFailed;
              return '';
            })
        : Promise.resolve('');

      smsStep
        .then(function (okPhone) {
          // 2. The back in stock subscription itself (per variant).
          return subscribeBackInStock(key, variantId, email, okPhone).then(function () { return okPhone; });
        })
        .then(function (okPhone) {
          // 3. Optional newsletter opt-in. Fire and forget.
          if (email && optinEl && optinEl.checked && cfg.emailListId) {
            subscribeToList(key, cfg.emailListId, { email: email }, source).catch(function () {});
          }
          if (email && window.klaviyo && typeof window.klaviyo.push === 'function') {
            try { window.klaviyo.push(['identify', { email: email }]); } catch (e) {}
          }

          var channels = [];
          if (email) channels.push('email');
          if (okPhone) channels.push('sms');
          var tmpl = channels.length === 2 ? S.successBoth : (okPhone ? S.successSms : S.successEmail);
          successText.textContent = tmpl.replace('{item}', itemName(v)) + (smsNote ? ' ' + smsNote : '');

          busy = false;
          submitEl.disabled = false;
          submitEl.removeAttribute('aria-busy');
          setStatus('');
          formView.hidden = true;
          trigger.hidden = true;
          successView.hidden = false;
          successView.focus();

          var detail = { variantId: variantId, productTitle: cfg.productTitle, variantTitle: v && v.t, channels: channels };
          root.dispatchEvent(new CustomEvent('kbis:subscribed', { bubbles: true, detail: detail }));
          if (typeof window.gtag === 'function') {
            try { window.gtag('event', 'back_in_stock_signup', { item_id: variantId, item_name: cfg.productTitle, item_variant: v && v.t, method: channels.join('+') }); } catch (e) {}
          }
        })
        .catch(function (err) {
          var f = fieldFromError(err || {});
          fail(f.msg, f.el);
        });
    }

    render();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-kbis]').forEach(init);
  }

  window.KlaviyoBIS = { init: init, initAll: initAll, normalizePhone: normalizePhone };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
})();
